import { Component, Output, EventEmitter } from '@angular/core';
import { SortItem } from '../services/position-services';

@Component({
  selector: 'tu-sort',
  templateUrl: './sort.component.html'
})

export default class SortComponent {

  constructor() {
  }

  public dptUp: boolean = false;
  public dptDown: boolean = false;

  public titleUp: boolean = false;
  public titleDown: boolean = false;

  public odateUp: boolean = false;
  public odateDown: boolean = true;

  @Output('update-sort') updateSort = new EventEmitter<SortItem>();
  sortItem = new SortItem();

  public dptColor: string = 'black';
  public titleColor: string = 'black';
  public odateColor: string = 'green';

  onClickDpt() {
    this.dptUp = !this.dptUp;
    this.dptDown = !this.dptUp;

    this.titleUp = false;
    this.titleDown = false;

    this.odateUp = false;
    this.odateDown = false;

    this.dptColor = 'green';
    this.titleColor = 'black';
    this.odateColor = 'black';

    this.sortItem.name = 'dpt';
    this.sortItem.isAsc = this.dptUp ? true : false;

    this.updateSort.emit(this.sortItem);
  }

  onClickTitle() {
    this.titleUp = !this.titleUp;
    this.titleDown = !this.titleUp;

    this.dptUp = false;
    this.dptDown = false;

    this.odateUp = false;
    this.odateDown = false;

    this.dptColor = 'black';
    this.titleColor = 'green';
    this.odateColor = 'black';

    this.sortItem.name = 'title';
    this.sortItem.isAsc = this.titleUp ? true : false;

    this.updateSort.emit(this.sortItem);
  }

  onClickODate() {
    this.odateUp = !this.odateUp;
    this.odateDown = !this.odateUp;

    this.titleUp = false;
    this.titleDown = false;

    this.dptUp = false;
    this.dptDown = false;

    this.dptColor = 'black';
    this.titleColor = 'black';
    this.odateColor = 'green';

    this.sortItem.name = 'odate';
    this.sortItem.isAsc = this.odateUp ? true : false;

    this.updateSort.emit(this.sortItem);
  }
}



// WEBPACK FOOTER //
// ./src/app/sorts/sort.component.ts